import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { ThresholdAxios } from "../../axios/threshold/threshold.axios";
import { GetUserCurrentThresholdsDto } from "../../model/threshold/dto/GetUserCurrentThresholdsDto";
import { GetUserCurrentThresholdsResponseDto } from "../../model/threshold/dto/GetUserCurrentThresholdsResponseDto";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "./../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

interface ThresholdReducer {
  threshold: GetUserCurrentThresholdsResponseDto | null;
  thresholdLoading: boolean;
}

const initialState = Object.freeze<ThresholdReducer>({
  threshold: null,
  thresholdLoading: false,
});

const getThresholds = AtiraThunk<
  GetUserCurrentThresholdsResponseDto,
  GetUserCurrentThresholdsDto
>(`/threshold/:id`, ThresholdAxios.getThreshold);

const thresholdSlice = createSlice({
  name: "threshold",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getThresholds.pending, (state) => {
      state.thresholdLoading = true;
    });
    addCase(getThresholds.fulfilled, (state, action) => {
      state.threshold = action.payload;
      state.thresholdLoading = false;
    });
    addCase(getThresholds.rejected, (state) => {
      state.thresholdLoading = false;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const thresholdActions = {
  getThresholds,
};

export default thresholdSlice.reducer;
